import React from 'react'
import { EditForm } from '@morningtrain/react-crud'
import ContentWrapper from 'ui/layouts/ContentWrapper'

export default class EditLayout extends EditForm {
  render () {
    return (
      <ContentWrapper>
        {super.render()}
      </ContentWrapper>
    )
  }
}
